// extracted by mini-css-extract-plugin
export var container = "_8q-0";
export var fallback = "_8q-5";
export var fallbackIcon = "_8q-6";
export var hidden = "_8q-2";
export var image = "_8q-3";
export var loaded = "_8q-4";
export var placeholder = "_8q-1";